const LABEL_BASE = 'CONTACTS_LAYOUT.SIDEBAR.BOOKINGS';

export const BOOKING_TYPES = [
  { value: 'car_rental', icon: 'i-lucide-car' },
  { value: 'flight', icon: 'i-lucide-plane' },
  { value: 'hotel', icon: 'i-lucide-building-2' },
  { value: 'package', icon: 'i-lucide-package' },
  { value: 'other', icon: 'i-lucide-ticket' },
].map(type => ({
  ...type,
  labelKey: `${LABEL_BASE}.TYPE_OPTIONS.${type.value.toUpperCase()}`,
}));

export const DEFAULT_BOOKING_TYPE = 'car_rental';

export const PACKAGE_COMPONENT_TYPES = BOOKING_TYPES.filter(
  type => type.value !== 'package'
);

export const STATUS_OPTIONS = [
  'confirmed',
  'pending',
  'completed',
  'cancelled',
].map(value => ({
  value,
  labelKey: `${LABEL_BASE}.STATUS_OPTIONS.${value.toUpperCase()}`,
}));

const STATUS_COLORS = {
  confirmed: 'bg-n-green-3 text-n-green-11',
  pending: 'bg-n-amber-3 text-n-amber-11',
  cancelled: 'bg-n-ruby-3 text-n-ruby-11',
  completed: 'bg-n-blue-3 text-n-blue-11',
};

export const typeIcon = type =>
  (BOOKING_TYPES.find(item => item.value === type) || BOOKING_TYPES.at(-1))
    .icon;

export const statusColor = status =>
  STATUS_COLORS[status] || STATUS_COLORS.confirmed;
